import { AppContextImpl } from "./context/application-context";
import { ApplicationContextFactory } from "./context/application-context-factory";
import { LoggingServiceImplementation } from "./loggingSvc";
import * as Jsll from "../../ShellCommon/logger/jsll-types";
declare var awa: any;

export interface NonStandardLoggingInformation {
  context: AppContextImpl;
  version: string;
  sessionId?: string;
  eventPrefix?: string;
}

export interface ErrorLogDetails {
  /** Marks error telemetry as unhandled. */
  isUnhandled: boolean;

  /** The name of the error. */
  errorName?: string;
}

enum LogType {
  Error,
  Information
}

let appContext: AppContextImpl;
let angularLoggingService: LoggingServiceImplementation;

export let extendTelemetryContext = (data: Jsll.ICoreData): void => {
  if ((<any>window).awa) {
    (<any>window).awa.extendCoreData(data);
  }
};

// overridden by ASD
export let getNonStandardLoggingInformation = (): NonStandardLoggingInformation => {
  if (!appContext) {
    appContext = ApplicationContextFactory.create();
  }
  let version = $("#versionTag").text().trim();
  return {
    context: appContext,
    version: version
  };
};

export let nonStandardPushInformationEvent = (
  eventSource: string,
  message: string,
  serviceName?: string,
  logImmediately?: boolean
) => {
  // remove bearer token if present in message
  let sanitizedMessage = removeBearerToken(message);
  if (!trySendingThroughLoggingService(sanitizedMessage, LogType.Information, serviceName, logImmediately)) {
    let loggingInfo = getNonStandardLoggingInformation();
    let appContext = loggingInfo.context;
    if ((<any>window).awa) {
      let event: any = {
        name: "MSEG.ServiceDesk.Information",
        data: {
          "MSEG.ServiceDesk.Information": getCommonPartCFields(eventSource)
        }
      };
      event.data["MSEG.ServiceDesk.Information"].informationType = 0;
      event.data["MSEG.ServiceDesk.Information"].informationData = sanitizedMessage;
      event.data["MSEG.ServiceDesk.Information"].vendorSiteName =
        (appContext && appContext.vendorSiteName) || "no-vendor-site-name";
      awa.vortexEvents.SendOrScheduleEvent(event, logImmediately);
    }
  }
};

let trySendingThroughLoggingService = (
  message: string,
  logType: LogType,
  serviceName?: string,
  logImmediately?: boolean
) => {
  if ((<any>window).angular) {
    let element = angular.element("body div");
    if (element && element.injector) {
      let injector = element.injector();
      if (injector && injector.has("loggingService")) {
        angularLoggingService = <LoggingServiceImplementation>injector.get("loggingService");
        if (angularLoggingService) {
          switch (logType) {
            case LogType.Error:
              angularLoggingService.logError(
                message,
                undefined,
                undefined,
                {
                  serviceName: serviceName
                },
                logImmediately
              );
              return true;
            case LogType.Information:
              angularLoggingService.logInfo(
                message,
                undefined,
                {
                  serviceName: serviceName
                },
                logImmediately
              );
              return true;
            default:
              throw new Error(`Log type not supported ${logType}`);
          }
        }
      }
    }
  }
  return false;
};

export let nonStandardPushErrorEvent = (
  eventSource: string,
  message: string,
  details: ErrorLogDetails,
  serviceName?: string,
  logImmediately?: boolean
) => {
  if (!trySendingThroughLoggingService(message, LogType.Error, serviceName, logImmediately)) {
    console.error(message);
    if ((<any>window).awa) {
      let event: any = {
        name: "MSEG.ServiceDesk.Error",
        data: {
          "Ms.Telemetry.Error": {},
          "MSEG.ServiceDesk.Error": getCommonPartCFields(eventSource)
        }
      };
      event.data["Ms.Telemetry.Error"].errorName = details.errorName || "NonStandardError";
      event.data["Ms.Telemetry.Error"].errorMessage = message || "no-error-message";
      event.data["MSEG.ServiceDesk.Error"].isUnhandled = details.isUnhandled || false;
      awa.vortexEvents.SendOrScheduleEvent(event, logImmediately);
    }
  }
};

let getCommonPartCFields = (eventSource: string) => {
  let loggingInfo = getNonStandardLoggingInformation();
  let appContext = loggingInfo.context;
  let awaConfig: Jsll.ITrackerInitOptions = { coreData: {} };
  if (awa) {
    awaConfig = awa.getConfig() || { coreData: {} };
  }
  return {
    // Part C
    agentEmail: (appContext && (appContext.agentUpn || appContext.agentEmail)) || "no-agent-email",
    agentId: (appContext && appContext.agentId) || "no-agent-id",
    presence: "",
    vendorSiteId: (appContext && appContext.vendorSiteId) || "no-vendor-site-id",
    parentSessionId: "non-standard-" + (loggingInfo.eventPrefix + "-" || "") + eventSource,
    sessionId: loggingInfo.sessionId || "no-session-id",
    agentMode: (appContext && appContext.agentMode) || "no-agent-mode",
    sdVersion: loggingInfo.version || "unknown",
    pageTags: awaConfig.coreData.pageTags && JSON.stringify(awaConfig.coreData.pageTags),
    pageName: awaConfig.coreData.pageName,
    uri: removeBearerToken(awaConfig.coreData.referrerUri)
  };
};

let removeBearerToken = (bearerTokenString: string) => {
  if (bearerTokenString && typeof bearerTokenString === "string") {
    if (bearerTokenString.indexOf("id_token") >= 0) {
      bearerTokenString = bearerTokenString.split("id_token")[0];
    } else if (bearerTokenString.indexOf("access_token") >= 0) {
      bearerTokenString = bearerTokenString.split("access_token")[0];
    }
  }
  return bearerTokenString;
};
